import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import styles from '../_style/index.less';
import { dispatch } from '@@/store';
import StickyContainer from '@/components/StickyContainer';
import { showCarDetail } from '@/components/CarDetail';
import { showInfo } from '@/components';
import { fontEndConfig } from '@/shared/utils';
// 定义关联的store文件
const mapStateToProps = (rootState) => ({
    dealDetail: rootState.dealDetail,
});
// 定义车辆基本信息类
class CarInfo extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const param = {
            auctionId: this.props.id,
        };
        dispatch.dealDetail.getCarInfo(param);
    }
    render() {
        const { carInfo } = this.props.dealDetail;
        const type = this.props.type; // 1：处理 2:处理详情
        const { carmodelName, license, locationName, vin, rankDesc, rankLevel, firstImage, platformId, status } = carInfo;
        let statusName = '';
        switch (status) {
            case 3:
                statusName = '竞拍中';
                break;
            case 50:
                statusName = '结标中';
                break;
            case 5:
                statusName = '成交';
                break;
        }
        return (<StickyContainer>
        <div className={styles.top_info}>
          <div className={styles.top_left}>
            <img src={firstImage}/>
          </div>
          <div>
            <div onClick={() => {
            showCarDetail(carInfo.goodsIdStr);
        }} className={styles.top_title}>{carmodelName}
            </div>
            <div className={styles.top_cont}>
              <span>{statusName}</span>
              <span>{license}</span>
              <span>{rankLevel}{rankDesc}</span>
              <span>{locationName}</span>
              <span>VIN码：{vin}</span>
            </div>
            <div style={{ fontSize: '16px', display: 'flex', paddingTop: '20px', color: '#1a1a1a' }}>
              <div>
                <div>卖家经销商：<span style={{ color: '#007cff', cursor: 'pointer' }} onClick={() => {
            showInfo('seller', carInfo.sellerCode);
        }}>{carInfo.sellerName}
                </span></div>
                <div style={{ paddingTop: '4px' }}>起拍价：{carInfo.auctionPriceY}</div>
                {type === 2 && (<div style={{ paddingTop: '4px' }}>成交价：{carInfo.priorityOffer}</div>)}
              </div>
              <div style={{ marginLeft: '24px' }}>
                <div>车辆竞拍实际结束时间：{carInfo.endTime}</div>
                <div style={{ paddingTop: '4px' }}>保留价：{carInfo.basePriceY}</div>
                {type === 2 && (<div style={{ paddingTop: '4px' }}>
                      <span>合手价：{carInfo.finalOffer} </span>
                      <span style={{ color: '#727272', fontSize: '14px' }}>(佣金{carInfo.brokerageY} ；服务费{carInfo.commissionY})</span>
                      {carInfo.buyerName && carInfo.phone ? <span style={{ marginLeft: '58px' }}>买家信息：{carInfo.buyerName} {carInfo.phone}</span> : fontEndConfig.noValueReplace}
                      <span style={{ marginLeft: '17px', backgroundColor: '#f2f3f5', borderRadius: '2px', padding: '3px 4px', border: 'solid 1px #eaeaea', fontSize: '12px', color: '#666666' }}>{platformId === 10 ? '车易拍' : '自有'}车商</span>
                    </div>)}
              </div>
            </div>
          </div>
        </div>
      </StickyContainer>);
    }
}
export default connect(mapStateToProps)(CarInfo);
